import { companyDetails } from 'utils/companyDetails';


export const termDataOne = [
  {
    id: 1,
    title: '1.Introduction',
    content: `Welcome to ITER Mobility Pvt Ltd ("ITER", "we", "us", or "our"). These Terms and Conditions ("Terms") govern your access to and use of the ITER mobile application ("App") and related services (collectively, the "Services"). By downloading, installing, or using the App, you agree to be bound by these Terms. If you do not agree to all of these Terms, you may not access or use the Services.`,
  },
  {
    id: 2,
    title: '2. User Eligibility',
    content: `You must be at least 18 years old and have the legal capacity to enter into a binding contract to use the Services. You are also responsible for ensuring that any device you use to access the Services is authorized and compatible.
    You are a resident of India.`,
  },
  {
    id: 3,
    title: '3. User Accounts',
    content: `You may be required to create an account to access certain features of the Services. You are responsible for maintaining the confidentiality of your account information, including your username and password. You are also responsible for all activity that occurs under your account.`,
  },

  {
    id: 4,
    title: '4. Use of the Services',
  },
];

export const termDataTwo = [
  {
    title: '4.1 As a Rider:',
    body: [
      {
        content: [
          `You agree to use the Services only for lawful purposes and in accordance with all applicable laws and regulations`,
          `You agree to provide accurate and complete information when requesting a ride.`,
          `You agree to treat drivers with respect and courtesy.`,
          `You agree to pay for your rides in accordance with the fare structure displayed in the App.`,
          `You agree not to use the Services for any illegal or unauthorized activity, including but not limited to:`,
          `Transporting illegal goods or substances.`,
          `Damaging vehicles or property.`,
          `Disrupting or interfering with the Services.`,
          `Engaging in violent or threatening behaviour.`,
        ],
      },
    ],
  },
  {
    title: '4.2 As a Driver:',
    body: [
      {
        content: [
          `You agree to maintain a valid driver's license and meet all insurance requirements as mandated by Indian regulations.`,
          `You agree to maintain your vehicle in a safe and clean condition.`,
          `You agree to provide a safe and courteous ride to passengers.`,
          `You agree to comply with all traffic laws and regulations.`,
          `You agree to respect the privacy of passengers and not to disclose their personal information.`,
        ],
      },
    ],
  },
];

export const termDataThree = [
  {
    id: 1,
    title: '5. Payment',
    content: `You agree to pay for your rides using the payment method(s) linked to your account. ${companyDetails?.companyName} reserves the right to modify its fare structure at any time. You will be notified of any changes in advance.`,
  },
  {
    id: 2,
    title: '6. Intellectual Property',
    content: `The Services contain intellectual property owned by ${companyDetails?.companyName}, including trademarks, copyrights, and patents. You are granted a non-exclusive, non-transferable license to use the Services in accordance with these Terms.`,
  },
  {
    id: 3,
    title: '7. Disclaimer of Warranties',
    content: `THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. ${companyDetails?.companyName} DOES NOT WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED, ERROR-FREE, OR VIRUS-FREE.`,
  },

  {
    id: 4,
    title: '8. Limitation of Liability',
    content: `${companyDetails?.companyName} SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICES, EVEN IF ${companyDetails?.companyName} HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.`,
  },
  {
    id: 5,
    title: '9. Indemnification',
    content: `You agree to indemnify and hold harmless ${companyDetails?.companyName}, its officers, directors, employees, agents, and licensors from and against any and all claims, demands, losses, liabilities, costs, or expenses (including attorneys' fees) arising out of or related to your use of the Services or your violation of these Terms.`,
  },
  {
    id: 6,
    title: '10. Termination',
    content: `${companyDetails?.companyName} may terminate your access to the Services at any time, for any reason, with or without notice. You may also terminate your account at any time.`,
  },
  {
    id: 7,
    title: '11. Governing Law',
    content: `These Terms shall be governed by and construed in accordance with the laws of India.`,
  },
  {
    id: 8,
    title: '12. Dispute Resolution',
    content: `Any dispute arising out of or relating to these Terms shall be subject to the exclusive jurisdiction of the courts located in India.`,
  },
  {
    id: 9,
    title: '13. Entire Agreement',
    content: `These Terms constitute the entire agreement between you and ${companyDetails?.companyName} regarding your use of the Services.`,
  },
  {
    id: 10,
    title: '14. Amendment',
    content: `${companyDetails?.companyName} reserves the right to modify these Terms at any time. The revised Terms will be effective upon posting on the App. You are advised to review the Terms regularly for any changes. Continued use of the Services after the posting of revised Terms means that you accept and agree to the changes.`,
  },

  {
    id: 11,
    title: '15. Severability',
    content: `If any provision of these Terms is held to be invalid or unenforceable, such provision shall be struck and the remaining provisions shall remain in full force and effect.`,
  },
];

export const termDataFour = [
  {
    title: '16. Reporting Lost Property',
    body: [
      {
        subTitle:
          'If you lose an item in an ${companyDetails?.companyName} vehicle, please report it immediately through the App within 24 hours of completing your ride. To report a lost item, follow these steps:',
        content: [
          `Open the ${companyDetails?.companyName} App.`,
          `Go to your ride history and select the specific ride where you believe you lost the item.`,
          `Locate the "Report Lost Item" option.`,
          `Provide a detailed description of the lost item, including its size, color, brand (if applicable), and any unique features.`,
          `Attach a clear picture of the lost item (if available).`,
        ],
      },
    ],
  },
];

export const termDataFive = [
  {
    id: 1,
    title: '17. Search for Lost Property',
    content: `${companyDetails?.companyName} drivers will be notified of reported lost items. They will be instructed to check their vehicle thoroughly after each ride and report any found items to the ${companyDetails?.companyName} support team.`,
  },
];

export const termDataSix = [
  {
    title: '18. Storage and Return of Lost Property',
    body: [
      {
        content: [
          `Found items will be stored at the ${companyDetails?.companyName} office for a period of 30 days.`,
          `${companyDetails?.companyName} will attempt to contact you using the information provided in your App profile.`,
          `You will be responsible for arranging the collection or return of your lost item within the 30-day storage period.`,
          `${companyDetails?.companyName} may charge a reasonable administrative fee for the storage and return of your lost item.`,
        ],
      },
    ],
  },
  {
    title: '19. Unclaimed Lost Property',
    body: [
      {
        content: [
          `If a lost item remains unclaimed after 30 days, ${companyDetails?.companyName} reserves the right to donate the item to charity or dispose of it responsibly.`,
        ],
      },
    ],
  },
  {
    title: '20. User Responsibility',
    body: [
      {
        content: [
          `You are responsible for securing your belongings during your ride.`,
          `${companyDetails?.companyName} is not liable for any loss or damage to your belongings left in a vehicle.`,
          `You understand that ${companyDetails?.companyName} cannot guarantee the recovery of lost items.`,
        ],
      },
    ],
  },
];

export const termDataSeven = [
  {
    id: 1,
    title: '21. Disclaimer',
    content: `${companyDetails?.companyName} assumes no responsibility for the condition of lost items upon return.`,
  },
  {
    id: 2,
    title: '22. Governing Law',
    content: `These Terms shall be governed by and construed in accordance with the laws of India.`,
  }
];

export const termDataEight = [
  {
    title: 'Please note:',
    body: [
      {
        content: [
          `You are advised to review these Terms periodically for any changes. Continued use of the App following the posting of revised Terms means that you accept and agree to the changes.`,
          `This is a sample template and may need to be adapted to comply with specific Indian laws and regulations. You may want to consult with a legal professional to ensure compliance.`,
        ],
      },
    ],
  },
];

export const termDataNine = [
  {
    id: 1,
    title: '24. Contact Us',
    content: `If you have any questions about these Terms`,
  },
];
